import {
  gql,
  useMutation,
  type UseMutationExecute,
  type UseMutationState,
} from 'urql'

import { useSearchTrackingSession } from './tracking-session-provider'

export enum UserRating {
  None = 0,
  Positive = 1,
  Negative = 2,
}

const SEND_SEARCH_TRACKING_EVENTS_QUERY = gql`
  mutation SendSearchTrackingEvents(
    $searchSessionToken: String!
    $searchEvent: String!
    $kmSessionToken: String!
    $kmEvent: String!
  ) {
    resultSearch: sendSearchTrackingEvents(
      sessionToken: $searchSessionToken
      event: $searchEvent
      source: "web-search"
    ) {
      success
    }
    resultKm: sendKmTrackingEvents(
      sessionToken: $kmSessionToken
      event: $kmEvent
      source: "web-search"
    ) {
      success
    }
  }
`

export const useInbentaSearchKmItemTracking = (
  searchCode: string,
  clickCode: string,
  externalCode: string
) => {
  const session = useSearchTrackingSession()

  const executeMutation = useMutation(SEND_SEARCH_TRACKING_EVENTS_QUERY)[1]

  return async () =>
    executeMutation({
      searchSessionToken: session?.search?.sessionToken,
      searchEvent: JSON.stringify({
        type: 'external_click',
        data: {
          searchCode,
          externalCode,
        },
      }),
      kmSessionToken: session?.km?.sessionToken,
      kmEvent: JSON.stringify({
        type: 'click',
        data: {
          code: clickCode,
        },
      }),
    })
}

export const useInbentaSearchItemTracking = (
  searchCode: string,
  clickCode: string,
  externalCode: string
) => {
  const session = useSearchTrackingSession()

  const executeMutation = useMutation(SEND_SEARCH_TRACKING_EVENTS_QUERY)[1]

  return async () =>
    executeMutation({
      searchSessionToken: session?.search?.sessionToken,
      searchEvent: JSON.stringify({
        type: 'click',
        data: {
          code: clickCode,
        },
      }),
      kmSessionToken: session?.km?.sessionToken,
      kmEvent: JSON.stringify({
        type: 'external_click',
        data: {
          searchCode,
          externalCode,
        },
      }),
    })
}

const SEND_KM_TRACKING_EVENTS_QUERY = gql`
  mutation SendKmTrackingEvents($sessionToken: String!, $event: String!) {
    result: sendKmTrackingEvents(
      sessionToken: $sessionToken
      event: $event
      source: "web-faq"
    ) {
      success
    }
  }
`

export type KmTrackingEvent = {
  type: 'rate' | 'click'
  data: {
    code: string
    value?: UserRating
    comment?: string
  }
}

type UseInbentaKmTracking = (
  e: KmTrackingEvent
) => [UseMutationState, UseMutationExecute]

export const useInbentaKmTracking: UseInbentaKmTracking = (event) => {
  const session = useSearchTrackingSession()

  const [data, _execute] = useMutation(SEND_KM_TRACKING_EVENTS_QUERY)

  const executeMutation: UseMutationExecute = async () =>
    _execute({
      sessionToken: session?.km?.sessionToken,
      event: JSON.stringify(event),
    })

  return [data, executeMutation]
}
